import { createSlice } from '@reduxjs/toolkit';
import { state } from './state';
import { createChat, getHistoryListing, getHistoryMessages } from './actionCreator';
import { getChatBotMessages } from '../utils';

export const chatBotSlice = createSlice({
    name: 'chatBot',
    initialState: state,
    reducers: {
        setReturnFromRazorpay: (state, action) => {
            state.returnFromRazorpay = action.payload;
        },
        setMessages: (state, action) => {
            state.messages.push(action.payload);
        },
        resetMessages: (state) => {
            state.messages = []; // Reset messages to an empty array
            state.showHistory = false;
        },
        setLeoButton: (state, action) => {
            state.leoButton = action.payload;
            state.messages=[];
        },
        setShowHistory: (state, action) => {
            state.showHistory = action.payload;
        },
        resetExpireAllPayments: (state, action) => {
            state.expireAllPayments = action.payload;
        },
      
    },
    extraReducers: (builder) => {
        builder.addCase(createChat.pending, (state) => {
            state.isLoading = true;
            state.isError = '';
        });
        builder.addCase(createChat.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = '';
            state.isSuccess = true;

            const data = action?.payload?.resp?.data;
            state.chatMessages = data?.botMessage;
            state.chatData = data;
            state.refundType = data?.payload?.payload?.type;

            const messages = getChatBotMessages(data);
            state.messages.push(...messages);
        });

        builder.addCase(createChat.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = action.error.message || 'Something went wrong';
        });

        //  Add getHistoryListing reducer
        builder.addCase(getHistoryListing.pending, (state) => {
            state.isError = '';
        });
        builder.addCase(getHistoryListing.fulfilled, (state, action) => {
            state.isSuccess = true;
            state.isError = '';
            state.historyList = action.payload?.historyList || [];
        });
        builder.addCase(getHistoryListing.rejected, (state, action) => {
            state.isError = action.error.message || 'Failed to fetch history';
        });

        // Add getHistoryMessages reducer
        builder.addCase(getHistoryMessages.pending, (state) => {
            state.isError = '';
           state.messages=[]; 

        });
        builder.addCase(getHistoryMessages.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.isError = '';
            state.showHistory = true;

            const historyData = action?.payload?.history || [];

            historyData.forEach((item) => {
                let text = '';

                if (item.from === 'customer') {
                    state.messages.push({
                        text:item?.data?.chat_input,
                        sender: 'user',
                    });
                } else if (item.from === 'bot') {
                    const messages = getChatBotMessages(item?.data);
                    state.messages.push(...messages);
                }       
            });
        });

        builder.addCase(getHistoryMessages.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = action.error.message || 'Failed to fetch history';
        });
    },
});

export const { setReturnFromRazorpay, setMessages, resetMessages, setLeoButton,setShowHistory,resetExpireAllPayments  } =
    chatBotSlice.actions;
export default chatBotSlice.reducer;
